import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';

import { useCtxGlobal } from '@client/app/Container';
import { getHumanFiltersCountV13 } from '@helpers/search/Search';

import { getTitle } from './helpers';

const BaloonMessageNoResults = ({
  isAgencySrp,
  className,
  isMap,
}) => {
  const { model } = useCtxGlobal();
  const mainCls = `nrHeader${isMap ? 'map' : ''}`;
  const activeFiltersCount = getHumanFiltersCountV13(model?.queryFilters || {});
  return (
    <Grid className={`${mainCls} p--m ${className}`.trim()} direction="column" align={!isMap ? 'center' : ''} justify="center">
      <p className={`${mainCls}_title tp-s--l tp-w--l mb--${!isMap ? 'x' : ''}s c-txt--f0`}>
        {getTitle({ isAgencySrp })}
      </p>
      {activeFiltersCount > 0 && (
        <p className={`${mainCls}_sub-title tp-s--m tp-w--${isMap ? 'm' : 's'} c-txt--f0`}>
          Prova a modificare o eliminare qualche filtro
        </p>
      )}
    </Grid>
  );
};

BaloonMessageNoResults.propTypes = {
  isAgencySrp: PropTypes.bool,
  isMap: PropTypes.bool,
  className: PropTypes.string,
};

BaloonMessageNoResults.defaultProps = {
  isAgencySrp: false,
  isMap: false,
  className: '',
};

export default BaloonMessageNoResults;
